import React, {useState, useContext, useEffect} from 'react';
import { Button } from 'antd';
import {useRouter} from 'next/router'

import { callApi } from '../../helpers/Api';
import UserContext from '../../context/UserContext';
import { pushRouteLogin } from '../auth/LoginRouting';

const FollowButton = (props) => {
    const {loggedInUser} = useContext(UserContext);
    const [following, setFollowing] = useState(false);
    const router = useRouter();

    useEffect(() => {
        if(loggedInUser) {
            callApi('/api/own/user_account_follow/' + props.user_account_id)
            .then(json => {
                setFollowing(json[0]?.followed ? json[0].followed : false)
            })
        } else {
            setFollowing(false);
        }
    }, [loggedInUser, props.user_account_id])

    const handleFollow = () => {
        callApi('/api/own/upsert/user_account_follow', {
            method: 'POST',
            body: JSON.stringify({leader_id: props.user_account_id, followed: !following})
        })
        .then(json => {
            setFollowing(!following)
            if(!following) {
                if(props.onFollow)
                    props.onFollow()
            } else {
                if(props.onUnfollow)
                    props.onUnfollow();
            }
        })
        .catch(err => {console.log(err)});
    }

    return (
        <Button size='small' style={{marginBottom: '12px'}}
            onClick={(e) => {
                e.preventDefault();
                if(!loggedInUser) {
                    pushRouteLogin(router)
                } else {
                    handleFollow()
                }
            }}
        >
            {following ? 'unfollow' : 'follow'}
        </Button>
    );
}

export default FollowButton;